import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CounponsTable from './CounponsTable';
import useStyles from '../../../booking-details/OnTripAnnouncement/styles';
import { useSelector } from 'react-redux';
import { dispatch } from 'store';
import { getCouponsCategories, getCouponsList, getCouponsViewHistory, setAddCouponsData } from 'store/slices/coupons';
import { devConsolelog } from 'helpers/utilityFunctions';
import { ALLOCATEDCOUPONS_CONSTANTS, AVAILABLECOUPONS_CONSTANTS } from './constants';

const AvailableCouponsTable = CounponsTable;
const AllocatedCouponsTable = CounponsTable;
const getOrgMemberCodes = (data) => {
    let orgCode = '';
    const memberCode = data?.code || '';
    const { organization = {} } = data || {};
    if (organization && Object?.keys(organization)?.length > 0) {
        if (organization?.code) {
            orgCode = organization?.code;
        }
    }

    return { orgCode, memberCode };
};
const CouponsMaster = (props) => {
    const { visibleOnAB = true } = props;
    const CouponsMasterData = useSelector((state) => state.coupons);

    const { couponsLoading = false, couponsData = {} } = CouponsMasterData || {};
    const { allocatedCoupons = [], availableCoupons = [] } = couponsData || {};
    const memberPriorityData = useSelector((state) => state?.memberPriority);
    const { orgCode, memberCode } = getOrgMemberCodes(memberPriorityData?.selectedMemberData);
    const [openCouponsModal, setOpenCouponsModal] = useState(false);
    const [viewHistoryModal, setViewHistoryModal] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        if (orgCode) {
            dispatch(
                getCouponsList({
                    orgCode,
                    visibleOnAB
                })
            );
            dispatch(getCouponsCategories());
        }
    }, [dispatch, orgCode]);

    const handleButtonClick = ({ item, type }) => {
        if (!item) return;
        switch (type) {
            case AVAILABLECOUPONS_CONSTANTS: {
                dispatch(setAddCouponsData({ ...(item || {}) }));
                setOpenCouponsModal(true);
                break;
            }

            case ALLOCATEDCOUPONS_CONSTANTS: {
                dispatch(getCouponsViewHistory({ couponCode: item?.code, orgCode }));
                setViewHistoryModal(true);
                break;
            }

            default: {
                break;
            }
        }
    };
    const commonProps = {
        handleButtonClick,
        isLoading: couponsLoading,
        setOpenCouponsModal,
        openCouponsModal,
        viewHistoryModal,
        setViewHistoryModal,
        orgCode,
        memberCode
    };
    return (
        <Box display="flex" flexDirection="column" gap="16px">
            <Typography my={2} className={classes.pageHeading}>
                Available coupons
            </Typography>
            <AvailableCouponsTable tableData={availableCoupons} {...commonProps} />

            <Typography my={2} className={classes.pageHeading}>
                Allocated coupons
            </Typography>
            <AllocatedCouponsTable tableData={allocatedCoupons} allocatedCouponsTable {...commonProps} />
        </Box>
    );
};

export default CouponsMaster;
